import { ELECTRICS } from "~/constants"

const kinds = Object.values(ELECTRICS)

export type validElectric = typeof kinds[number]

export const ELECTRIC_AMPS_MAP: Record<validElectric, number[]> = {
  [ELECTRICS.NONE]: [],
  [ELECTRICS.BASIC]: [],
  [ELECTRICS.E15]: [15],
  [ELECTRICS.E20]: [20],
  [ELECTRICS.E30]: [30],
  [ELECTRICS.E50]: [50],
  [ELECTRICS.SPLIT_15_30]: [15, 30],
  [ELECTRICS.SPLIT_20_30]: [20, 30],
  [ELECTRICS.SPLIT_30_50]: [30, 50],
  [ELECTRICS.SPLIT_15_30_50]: [15, 30, 50],
  [ELECTRICS.SPLIT_20_30_50]: [20, 30, 50],
}
